export default "__VITE_ASSET__CDdApyJJ__"